import { Component, Input, Output, EventEmitter } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';

export interface DisplayItem {
  id?: string;
  label: string;
  value: any;
  type?: 'text' | 'email' | 'link' | 'list' | 'user-row';
  icon?: string;
  metadata?: string | any;
}

@Component({
  selector: 'app-data-display',
  templateUrl: './data-display.component.html',
  styleUrls: ['./data-display.component.scss'],
  animations: [
    trigger('slideDown', [
      transition(':enter', [
        style({ height: '0', opacity: '0', overflow: 'hidden' }),
        animate('300ms ease-in-out', style({ height: '*', opacity: '1' }))
      ]),
      transition(':leave', [
        animate('300ms ease-in-out', style({ height: '0', opacity: '0' }))
      ])
    ])
  ]
})
export class DataDisplayComponent {
  @Input() items: DisplayItem[] = [];
  @Input() displayType: 'info-rows' | 'list-items' | 'grid' | 'user-table' | 'regions-sites' = 'info-rows';
  @Input() showEmpty: boolean = true;
  @Input() emptyMessage: string = 'No data available';
  @Input() emptyIcon: string = 'info';

  @Output() itemClicked = new EventEmitter<DisplayItem>();
  @Output() userInfo = new EventEmitter<DisplayItem>();
  @Output() userEdit = new EventEmitter<DisplayItem>();

  // Track which regions are expanded
  expandedRegions: Set<string> = new Set();

  onItemClick(item: DisplayItem): void {
    if (item.type === 'link') {
      this.itemClicked.emit(item);
    }
  }

  onUserInfo(user: DisplayItem): void {
    this.userInfo.emit(user);
  }

  onUserEdit(user: DisplayItem): void {
    this.userEdit.emit(user);
  }

  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  getEmailLink(email: string): string {
    return `mailto:${email}`;
  }

  toggleRegion(regionId: string): void {
    if (this.expandedRegions.has(regionId)) {
      this.expandedRegions.delete(regionId);
    } else {
      this.expandedRegions.add(regionId);
    }
  }

  isRegionExpanded(regionId: string): boolean {
    return this.expandedRegions.has(regionId);
  }
}